import { SearchableConversationFilterInput } from 'generated-graphql/types';
import { useSearchConversationsTotalCountQuery } from 'generated-graphql/hooks/apollo-hooks';
import {
  buildConversationVisibilityClause,
  ConversationVisibility
} from '../utils/buildConversationVisibilityClause';

type Props = {
  organizationId?: string;
  // Undefined for admins, who see the whole sub-account.
  visibility?: ConversationVisibility;
  skip?: boolean;
};

/**
 * Conversation total for the tab badge.
 *
 * Ignores the search box and the column filters on purpose, so it reads like the
 * Recruitment and Other counts, which only ever count by campaign type. The
 * filtered total is already on the toolbar.
 */
export const useCrossCampaignConversationsCount = ({
  organizationId,
  visibility,
  skip
}: Props) => {
  const visibilityClauses = buildConversationVisibilityClause(visibility);

  const filter: SearchableConversationFilterInput = {
    organizationId: { eq: organizationId ?? '' },
    ...(visibilityClauses.length > 0 ? { and: visibilityClauses } : {})
  };

  // The badge must not count conversations the viewer cannot open, so it waits
  // on the same restriction the list does.
  const { data, loading } = useSearchConversationsTotalCountQuery({
    variables: { filter },
    skip: skip || !organizationId
  });

  return {
    total: data?.searchConversations?.total ?? undefined,
    isLoading: loading
  };
};
